import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import { Page } from 'ecrion-components';
import EmailBlacklist from './EmailBlacklist';
import GoogleApiKey from './GoogleApiKey';
import PeopleMergeRules from './PeopleMergeRules';

var FormsPage = function FormsPage(_ref) {
  var theme = _ref.theme,
      history = _ref.history,
      onClose = _ref.onClose,
      location = _ref.location,
      pageName = _ref.pageName,
      rest = _objectWithoutProperties(_ref, ["theme", "history", "onClose", "location", "pageName"]);

  var icon = null;

  if (history || onClose) {
    icon = {
      type: 'close',
      onClick: undefined
    };

    if (history) {
      icon.onClick = function () {
        return history && history.return && history.return('/settings');
      };
    } else if (onClose) {
      icon.onClick = onClose;
    }
  }

  function getPageName() {
    switch (pageName.toLowerCase()) {
      case 'emailblacklist':
        return 'Email Blacklist';

      case 'googleapikey':
        return 'Google Api Key';

      case 'peoplemergerules':
        return 'Merging Rules';

      default:
        'Forms Settings';
    }
  }

  return React.createElement(React.Fragment, null, React.createElement(Page.ToolBar, {
    icon: icon,
    leftChildren: getPageName(),
    color: "navbar"
  }), React.createElement(Page.Common, null, pageName.toLowerCase() === 'emailblacklist' && React.createElement(EmailBlacklist, rest), pageName.toLowerCase() === 'googleapikey' && React.createElement(GoogleApiKey, rest), pageName.toLowerCase() === 'peoplemergerules' && React.createElement(PeopleMergeRules, rest)));
};

FormsPage.defaultProps = {
  onClose: null,
  pageName: ''
};
export default withTheme(FormsPage);